var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightEnglishLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 40,
    viewBox: "0 0 141 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3337 25.8972L26.5814 37.0302L25.5063 39.5416H25.5105C27.4467 39.9295 29.4403 39.9324 31.4367 39.5483C32.978 39.1622 34.4036 38.5483 35.6726 37.7251C35.8326 37.6193 35.9884 37.513 36.1434 37.4033L31.3337 25.8972Z",
    fill: "#73B158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4956 30.784C13.7913 31.2 14.1104 31.629 14.4589 32.063C14.1104 31.629 13.7913 31.2 13.4956 30.784Z",
    fill: "#7CBC56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0664 12.6157L21.0924 22.7061V22.7078L26.0746 24.2608L31.3336 25.8971L21.0664 12.6157Z",
    fill: "#226188"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0928 22.7077L26.075 24.2607L21.0928 22.7077Z",
    fill: "#7CBC56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.063 12.6156H21.0668V12.6139H21.063V12.6156Z",
    fill: "#7CBC56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6092 0.182404C18.1452 0.260139 17.6757 0.364345 17.2154 0.496285C14.8437 1.17111 12.7191 2.50731 11.0681 4.36161C10.844 4.61414 10.6241 4.8797 10.4168 5.15198L10.3519 5.24274C10.3117 5.29527 10.2753 5.34989 10.2363 5.40241L21.0668 12.6145L18.6092 0.182404Z",
    fill: "#29A5BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0691799 28.5653L10.7167 25.8987L1.69459 20.8615C0.0164094 23.9226 -0.131013 26.6992 0.0691799 28.5653Z",
    fill: "#73B158"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5947 17.2637L33.5972 17.2666L33.5947 17.2637Z",
    fill: "#7CBC56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0735241 28.626L0.0856696 28.7319L0.108704 28.8605C0.7876 32.8644 2.90847 35.3129 4.3718 36.5713L10.7168 25.899L0.0693359 28.5651C0.0693359 28.5844 0.0735241 28.6062 0.0735241 28.626Z",
    fill: "#68A855"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81301 36.933C4.83856 36.951 4.86536 36.9708 4.88714 36.9914L4.94829 37.0372C7.09219 38.6364 9.15442 39.6655 12.7885 39.8566C12.9995 39.8684 13.2131 39.8735 13.4263 39.8735C13.7911 39.8735 14.1634 39.8566 14.5307 39.8256C13.5578 36.2468 10.8749 26.4068 10.7166 25.9022V25.8988L4.37158 36.5716C4.52738 36.7052 4.67438 36.8258 4.81301 36.933Z",
    fill: "#5B9E54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5309 39.8255L14.5343 39.8276C14.5841 39.8221 14.6365 39.8187 14.6888 39.8137L14.7889 39.804C14.8337 39.7994 14.8777 39.7944 14.9225 39.7893C17.1724 39.5271 19.0055 38.7414 20.2247 38.2166C20.517 38.0909 20.7737 37.9804 20.9878 37.8985C18.5113 36.3934 16.5316 34.5277 14.9987 32.7209V32.7192C14.8111 32.4995 14.6335 32.2805 14.4593 32.0641C14.1109 31.6288 13.7913 31.2002 13.496 30.7838C13.3474 30.5758 13.2062 30.3712 13.0714 30.1704C12.9327 29.9691 12.805 29.7729 12.6835 29.5796C12.4984 29.2909 12.3284 29.0127 12.1701 28.7468C12.065 28.5699 11.9657 28.3984 11.8736 28.2333C11.6407 27.8228 11.4334 27.4564 11.2851 27.1315C10.7168 25.9038 10.7231 25.9189 10.7168 25.8987",
    fill: "#5A9252"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.338 2.43724C27.1381 1.57459 25.8184 0.929183 24.4208 0.520339C23.3884 0.16906 22.3201 -0.00279704 21.2445 0.00896826L21.1817 0.00770769C20.373 -0.0208652 19.55 0.0299777 18.7313 0.160657C18.6919 0.16738 18.6525 0.175363 18.6094 0.182086L21.0632 12.6142L28.5101 2.56624C28.4536 2.52338 28.3983 2.47884 28.338 2.43724Z",
    fill: "#1E98B0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.325 9.63461C33.1231 8.88542 32.8484 8.1442 32.5083 7.4282C31.8679 6.08696 31.0148 4.87429 29.9657 3.8234C29.5163 3.37296 29.0255 2.95067 28.5099 2.56619L21.063 12.6142H21.0668L33.3371 9.68041L33.325 9.63461Z",
    fill: "#218DA5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8309 14.404C33.8309 14.4588 33.8271 14.5152 33.8271 14.5699C33.8271 14.5114 33.8309 14.4567 33.8309 14.404Z",
    fill: "#7CBC56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0929 22.706C21.0862 22.7077 21.0569 22.7182 21.0435 22.7233C21.0594 22.7182 21.0761 22.7136 21.0929 22.7077V22.706Z",
    fill: "#7CBC56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0929 22.7077C21.0631 22.7161 21.0493 22.7207 21.0435 22.7232C21.0363 22.7241 21.0338 22.7257 21.0435 22.7232C20.5204 22.8779 20.4056 22.9157 10.7168 25.899L31.3341 25.8973L26.0751 24.2607L21.0929 22.7077Z",
    fill: "#95C65B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0435 22.7233C21.0493 22.7207 21.0665 22.7157 21.0929 22.7077C21.0761 22.7136 21.0594 22.7182 21.0435 22.7233Z",
    fill: "#7CBC56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81242 15.0511C7.80279 15.0557 7.79316 15.0604 7.7831 15.0654C5.2095 16.3743 3.13093 18.2845 1.92224 20.4623L1.90591 20.4921C1.83345 20.6157 1.76351 20.7396 1.69482 20.8636L10.7169 25.8987L7.81242 15.0511Z",
    fill: "#83BD5C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0669 12.6141L10.2364 5.40198C8.73327 7.48612 7.88182 9.93624 7.77587 12.5032C7.77587 12.5154 7.70886 13.4814 7.80895 15.0357C7.80895 15.0411 7.80895 15.0441 7.81272 15.0495C8.07867 14.9159 8.34545 14.7886 8.60763 14.6764V14.6697V14.6764C10.5028 13.8612 12.3112 13.3494 14.0346 13.0364C14.2428 12.9986 14.453 12.9637 14.6599 12.9309C15.3907 12.8183 16.1266 12.7347 16.8608 12.6755C18.2977 12.5616 19.7577 12.5876 21.0669 12.6158V12.6141Z",
    fill: "#25B3C4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0929 22.706L21.0669 12.6173L10.7168 25.899C20.4056 22.9157 20.5204 22.8758 21.0435 22.7233C21.0137 22.7317 21.0862 22.7077 21.0929 22.706Z",
    fill: "#9EC95B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0929 22.706L21.0669 12.6156V12.6173L21.0929 22.706Z",
    fill: "#7CBC56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7164 25.8989L21.0628 12.6176V12.6159C19.7569 12.5873 18.2973 12.5617 16.86 12.6751C16.1262 12.7348 15.3904 12.8184 14.6595 12.931C14.4526 12.9638 14.242 12.9987 14.0342 13.0365C12.3108 13.3495 10.5024 13.8613 8.60727 14.6765V14.6693V14.6765C8.34467 14.7887 8.07831 14.9156 7.81194 15.0496H7.80859L7.81194 15.0513L10.7164 25.8989Z",
    fill: "#91C45A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6831 29.5797C12.8046 29.7729 12.9323 29.9692 13.0709 30.1704C12.9323 29.9692 12.8046 29.7729 12.6831 29.5797Z",
    fill: "#7CBC56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.873 28.2333C11.9656 28.3985 12.0644 28.5699 12.1696 28.7468C12.0644 28.5699 11.9656 28.3985 11.873 28.2333Z",
    fill: "#7CBC56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1699 28.7466C12.3278 29.0126 12.4983 29.2908 12.6834 29.5795C12.4983 29.2908 12.3278 29.0126 12.1699 28.7466Z",
    fill: "#7CBC56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2852 27.1316C11.4426 27.4496 11.6403 27.8228 11.8732 28.2333C11.6403 27.8228 11.4426 27.4496 11.2852 27.1316Z",
    fill: "#7CBC56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2851 27.1315C10.9078 26.3823 10.7264 25.9218 10.7168 25.9037C10.7264 25.9218 10.9078 26.3823 11.2851 27.1315Z",
    fill: "#7CBC56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3339 25.8972C30.0716 26.404 28.798 26.9234 27.5302 27.4465C25.6213 28.2318 23.7069 29.0319 21.803 29.8336C20.534 30.3685 19.2717 30.9042 18.0144 31.4387C17.3858 31.7043 16.7613 31.9702 16.1398 32.2358C16.1364 32.2379 16.1335 32.2379 16.1297 32.2392L14.9985 32.7207C16.5314 34.5275 18.5111 36.3923 20.9876 37.8987C21.9935 38.4891 23.3028 38.9769 25.2004 39.4727L25.3193 39.5038C25.3223 39.5038 25.3252 39.5055 25.329 39.5055L25.5065 39.5416C25.5325 39.5463 25.4802 39.5366 25.5065 39.5416L26.5816 37.0302L31.3339 25.8972Z",
    fill: "#83BD5C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8032 29.8337C23.7071 29.0319 25.6215 28.2315 27.5305 27.4461C25.6215 28.2315 23.7071 29.0319 21.8032 29.8337Z",
    fill: "#7CBC56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7168 25.8989V25.9039C10.7264 25.9237 10.9078 26.3821 11.2851 27.1317C11.4426 27.4494 11.6407 27.8225 11.8736 28.2335C11.9657 28.3982 12.065 28.5696 12.1701 28.7465C12.3284 29.0125 12.4984 29.2907 12.6835 29.5798C12.805 29.773 12.9327 29.9693 13.0714 30.1705C13.2062 30.3714 13.3474 30.576 13.496 30.784C13.7913 31.2 14.1109 31.629 14.4593 32.0643C14.6306 32.2807 14.8111 32.4997 14.9987 32.719C15.3736 32.561 15.7518 32.3992 16.13 32.2391C16.1337 32.2379 16.1367 32.2379 16.14 32.2358C16.7615 31.9702 17.386 31.7042 18.0146 31.4391C19.2719 30.9042 20.5342 30.3701 21.8032 29.8336C23.7071 29.0318 25.6215 28.2318 27.5305 27.4465C28.7982 26.9233 30.0718 26.404 31.3341 25.8972L10.7168 25.8989Z",
    fill: "#91C45A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7293 11.9178C33.669 11.2068 33.5446 10.4891 33.3645 9.78319L33.3373 9.68066L21.0669 12.614V12.6157L33.5948 17.2638L33.5974 17.2663C33.6242 17.0075 33.6497 16.7684 33.6799 16.526C33.746 15.9995 33.8055 15.1662 33.8273 14.5696C33.8273 14.5149 33.831 14.4586 33.831 14.404C33.8503 13.5397 33.8139 12.7064 33.7293 11.9178Z",
    fill: "#20839F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.481 26.0819C41.3859 24.8465 41.1426 23.6578 40.7648 22.546L31.334 25.8974L41.0927 30.0661C41.3369 29.0682 41.6033 27.6559 41.481 26.0819Z",
    fill: "#5B9E54"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0927 30.0663L31.334 25.8972L36.1399 37.4003C39.5603 34.9569 40.6421 31.6618 40.6551 31.6257C40.7874 31.1962 40.8925 30.8286 40.9847 30.4785H40.9876L41.0211 30.3453C41.027 30.3189 41.037 30.2907 41.0429 30.2647L41.0467 30.2483C41.0601 30.1882 41.0764 30.1277 41.0927 30.0663Z",
    fill: "#68A855"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0664 12.6157L31.3336 25.8971C31.347 25.8693 32.59 23.6885 33.5948 17.2647L21.0664 12.6157Z",
    fill: "#267491"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6991 22.3515C39.5121 19.129 37.3008 17.0058 35.6796 15.8906C34.9123 15.3675 34.2586 15.0276 33.818 14.8314C33.8217 14.7444 33.8247 14.6566 33.8272 14.5692C33.8054 15.1662 33.7459 15.9995 33.6802 16.526C33.6496 16.7684 33.6207 17.0058 33.5952 17.2651C32.5904 23.6885 31.3474 25.871 31.334 25.897L40.7648 22.546C40.7418 22.4822 40.7217 22.4162 40.6991 22.3515Z",
    fill: "#5A9252"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5865 24.8689L86.1836 14.5957H83.8768L80.5045 24.8756L77.8312 14.5957H74.4883L78.9679 29.4208H81.6211L85.0445 18.9249L88.4683 29.4208H91.1202L95.5722 14.5957H92.2581L89.5865 24.8689Z",
    fill: "#000105"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4386 12.0835V12.5987H56.4018V22.8471C56.4018 25.1804 55.2186 26.5569 53.1426 26.6653V26.6704L52.9968 26.6716C52.9504 26.6716 52.9018 26.675 52.8544 26.6716L51.1197 26.6725C49.6648 26.6725 49.5513 28.4238 49.5513 28.9625V29.5726H52.8565H52.8741C56.2824 29.5726 59.72 27.5465 59.72 23.0194V10.3007H59.0085C58.4058 10.3007 56.4386 10.4288 56.4386 12.0835Z",
    fill: "#000105"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5085 24.0893C70.5085 25.183 70.3104 25.8343 69.8488 26.2671C69.0568 27.0268 68.2284 27.0878 67.2275 27.0878C65.6498 27.0878 64.7079 26.307 64.7079 25.0003C64.7079 23.7107 65.6284 22.9405 67.1701 22.9405H70.5085V24.0893ZM67.498 14.5363L67.3586 14.5371L67.2086 14.5363C66.0146 14.5363 65.2503 14.688 65.2423 14.6897C64.1722 14.8922 63.6533 15.6401 63.6533 16.9788V17.2801C64.202 17.2381 65.3889 17.1692 67.3615 17.1692C69.2734 17.1692 70.5085 18.2382 70.5085 19.8933V20.9841H66.5842C63.5737 20.9841 61.7046 22.5556 61.7046 25.0872C61.7046 26.3739 62.1184 27.5121 62.8701 28.2929C63.7078 29.1332 64.9043 29.5433 66.526 29.5433C68.1099 29.5433 69.0309 29.1837 70.0394 28.1727L70.596 27.6134V29.3967H73.6579V19.6584C73.6579 16.2616 71.5848 14.5371 67.498 14.5363Z",
    fill: "#000105"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.099 24.0893C127.099 25.183 126.901 25.8343 126.438 26.2671C125.646 27.0268 124.817 27.0878 123.818 27.0878C122.24 27.0878 121.297 26.307 121.297 25.0003C121.297 23.7107 122.218 22.9405 123.759 22.9405H127.099V24.0893ZM124.087 14.5363L123.949 14.5371L123.798 14.5363C122.605 14.5363 121.839 14.688 121.832 14.6897C120.761 14.8922 120.244 15.6401 120.244 16.9788V17.2801C120.792 17.2381 121.979 17.1692 123.951 17.1692C125.863 17.1692 127.099 18.2382 127.099 19.8933V20.9841H123.175C120.164 20.9841 118.294 22.5556 118.294 25.0872C118.294 26.3739 118.709 27.513 119.46 28.2929C120.298 29.1332 121.494 29.5433 123.115 29.5433C124.7 29.5433 125.619 29.1837 126.629 28.1727L127.186 27.6134V29.5375H130.248V19.6584C130.248 16.2616 128.175 14.5371 124.087 14.5363Z",
    fill: "#000105"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.568 26.9699L137.008 26.9636C135.899 26.9636 135.336 26.3896 135.336 25.2572V12.0212C135.336 10.4329 133.444 10.3094 132.864 10.3094H132.188V25.4921C132.188 27.3581 133.266 29.5372 136.306 29.5372H140.958V29.0145C140.958 28.5355 140.858 26.9699 139.568 26.9699Z",
    fill: "#000105"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.57 25.1738L108.169 14.4775H105.863L102.493 25.1793L99.8201 14.4775H96.4805L100.957 29.5312H103.608L107.03 18.8042L110.452 29.5312H113.103L117.551 14.4775H114.24L111.57 25.1738Z",
    fill: "#000105"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightEnglishLogo);
export default __webpack_public_path__ + "static/media/lightEnglishLogo.64e557eb2cb61edc0cd1b162deefc1de.svg";
export { ForwardRef as ReactComponent };